import { connect } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { IReduxRootState } from '../../app/reduxRootState.interface';
import AccountSecurity, { AccountSecurityFormType } from './AccountSecurity';
import AccountSecurityActions from './accountSecurityActions';
import { TextHelpers } from '../../utils/textHelpers';
import { AnyAction } from 'redux';
import { RevokeSessionActions } from './revokeSession/revokeSessionActions';
import { ErrorBoxActions } from '../../app/common/errorBox/errorBoxActions';

function mapStateToProps(state: IReduxRootState) {
    const cancelMember = state.app.presentationConfig.showSections['cancel.membership'] ?? false;
    const showSecretQuestion = state.app.presentationConfig.showSections['secretQuestion'] ?? false;
    const sessionRevocationEnabled = state.app.appConfig.SESSION_REVOCATION_ENABLED ?? true; // Enabled by-default
    const currentLanguage = state.app.locale;
    const accountSecurityUrl = state.app.clientConfig.accountSecurityUrl ?? {
        secretQuestionAnswer: '',
    };
    const oamUrl = TextHelpers.replaceLang(state.app.appConfig.OAM_URL ?? '', currentLanguage);
    const enableUserEmail2FAinOmni = state.app.appConfig.ENABLE_2FA_OMNI ?? '';
    const email2faFAQUrl = state.app.clientConfig.email2faFAQUrls?.[currentLanguage] ?? '';

    const secretQuestionAnswerUrl = TextHelpers.replaceLang(
        accountSecurityUrl.secretQuestionAnswer ?? '',
        currentLanguage,
        'account',
    );

    const isTwIchiba =
        state.app.clientConfig.internalIdentifier === 'rakuten_tw01' ||
        state.app.clientConfig.internalIdentifier === 'rakuten_tw01_web' ||
        state.app.clientConfig.internalIdentifier === 'rakuten_tw01_app';

    return {
        cancelMember,
        challengerPid: state.app.appConfig.CHALLENGER_ENABLED
            ? state.app.appConfig.CHALLENGER_PIDS.ACCOUNT_SECURITY
            : '',
        isOverlayOpen: state.accountSecurity.overlayOpen,
        isReady: state.app.memberLoggedIn,
        locale: state.app.locale,
        member: state.member,
        secretQuestionAnswerUrl,
        overlayContent: state.accountSecurity.overlayContent,
        sendOtpSuccess: state.accountSecurity.sendOtpSuccess,
        isVerifyEmailFromUpdateEmail: state.accountSecurity.isVerifyEmailFromUpdateEmail,
        tooManySendOtpRequests: state.accountSecurity.tooManySendOtpRequests,
        sessionRevocationEnabled,
        isSessionRevoked: state.accountSecurity.isSessionRevoked,
        signOutFromAllDevices: state.accountSecurity.signOutFromAllDevices,
        errorRevokingSession: state.accountSecurity.errorRevokingSession,
        showSecretQuestion,
        oamUrl,
        email2faFAQUrl,
        enableUserEmail2FAinOmni,
        isTwIchiba,
    };
}

function mapDispatchToProps(dispatch: ThunkDispatch<IReduxRootState, {}, AnyAction>) {
    return {
        closeAccountSecurityOverlay: () => {
            dispatch(AccountSecurityActions.closeAccountSecurityOverlay());
            dispatch(ErrorBoxActions.hideBox());
        },
        openAccountSecurityOverlay: () =>
            dispatch(AccountSecurityActions.openAccountSecurityOverlay()),
        changeAccountSecurityOverlay: (content: AccountSecurityFormType | undefined) =>
            dispatch(AccountSecurityActions.changeAccountSecurityOverlay(content)),
        handleSessionRevocation: () => dispatch(RevokeSessionActions.revokeUserSessions()),
    };
}

const AccountSecurityContainer = connect(mapStateToProps, mapDispatchToProps)(AccountSecurity);

export default AccountSecurityContainer;
